// Module
var code = `<div class="alert-selector-message">
    <terceraLabel visible="{{visible}}" text="{{label}}" />
    <textarea id="alert-message" class="alertMessage {{#if !isMessageTextValid}}alert-message-border{{/if}}" maxlength="100" placeholder="{{.placeholder}}">{{.messageText}}</textarea>
</div>`;
// Exports
export default code;